import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import auth from './authReducer';
import request from './requestReducer';
import dropboxes from './dropboxesReducer';
import assignment from './assignmentReducer';
import assignments from './assignmentsReducer';
import memberships from './membershipsReducer';
import notification from './notificationReducer';
import submission from './submissionReducer';
import submissions from './submissionsReducer';
import users from './usersReducer';
import runscript from './runscriptReducer';
import runscripts from './runscriptsReducer';
import logs from './logsReducer';
import { roles, roles_self } from './rolesReducer';
import semesters from './semestersReducer';

import { loadingBarReducer } from 'react-redux-loading-bar';

const rootReducer = combineReducers({
  routing: routerReducer,
  loadingBar: loadingBarReducer,
  auth,
  request,
  dropboxes,
  assignment,
  assignments,
  memberships,
  notification,
  submission,
  submissions,
  users,
  runscript,
  runscripts,
  logs,
  roles,
  roles_self,
  semesters,
});

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/